var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMacbuttons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80.99999999999999,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    className: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 15,
    width: 51,
    y: -1,
    x: -1
  }), /*#__PURE__*/React.createElement("g", {
    display: "none",
    overflow: "visible",
    y: 0,
    x: 0,
    height: "100%",
    width: "100%",
    id: "canvasGrid"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gridpattern)",
    strokeWidth: 0,
    y: 0,
    x: 0,
    height: "100%",
    width: "100%"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 6.32108,
    rx: 6.32108,
    id: "svg_1",
    cy: 6.32108,
    cx: 6.32108,
    strokeWidth: 0.1,
    fill: "#f43333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 6.32108,
    rx: 6.32108,
    id: "svg_3",
    cy: 6.32108,
    cx: 24.35817,
    strokeWidth: 0.1,
    fill: "#f2cb32"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 6.32108,
    rx: 6.32108,
    id: "svg_4",
    cy: 6.32108,
    cx: 42.41841,
    strokeWidth: 0.1,
    fill: "#50db3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacbuttons);
export default __webpack_public_path__ + "static/media/macbuttons.41b02ab2d7f88d048151b5af596f4b7b.svg";
export { ForwardRef as ReactComponent };